import React, { useState } from 'react';
import './NutritionCalculator.css';

// Updated and complete nutrition data for each ingredient per 100g
const nutritionData = {
  "Oats": { calories: 389, protein: 16.9, fat: 6.9, carbs: 66.3 },
  "Banana": { calories: 89, protein: 1.1, fat: 0.3, carbs: 23 },
  "Peanut Butter": { calories: 588, protein: 25, fat: 50, carbs: 20 },
  "Greek yogurt": { calories: 59, protein: 10, fat: 0.4, carbs: 3.6 },
  "Honey": { calories: 304, protein: 0.3, fat: 0, carbs: 82 },
  "Avocado": { calories: 160, protein: 2, fat: 15, carbs: 9 },
  "Egg": { calories: 155, protein: 13, fat: 11, carbs: 1.1 },
  "Grilled Chicken": { calories: 165, protein: 31, fat: 3.6, carbs: 0 },
  "Brown Rice": { calories: 111, protein: 2.6, fat: 0.9, carbs: 23 },
  "Broccoli": { calories: 55, protein: 3.7, fat: 0.6, carbs: 11.2 },
  "Salmon": { calories: 206, protein: 22, fat: 13, carbs: 0 },
  "Quinoa": { calories: 120, protein: 4.1, fat: 1.9, carbs: 21.3 },
  "Spinach": { calories: 23, protein: 2.9, fat: 0.4, carbs: 3.6 },
  "Almonds": { calories: 576, protein: 21.2, fat: 49.4, carbs: 21.6 },
  "Apple": { calories: 52, protein: 0.3, fat: 0.2, carbs: 14 },
  "Cucumber": { calories: 16, protein: 0.7, fat: 0.1, carbs: 3.6 },
  "Carrot": { calories: 41, protein: 0.9, fat: 0.2, carbs: 9.6 },
  "Blueberries": { calories: 57, protein: 0.7, fat: 0.3, carbs: 14 },
  "Strawberries": { calories: 32, protein: 0.7, fat: 0.3, carbs: 7.7 },
  "Whole grain bread": { calories: 265, protein: 9, fat: 3.2, carbs: 49 },
  "Olive oil": { calories: 884, protein: 0, fat: 100, carbs: 0 },
  "Lemon": { calories: 29, protein: 1.1, fat: 0.3, carbs: 9.3 },
  "Pasta": { calories: 131, protein: 5, fat: 1.1, carbs: 25 },
  "Chicken Breast": { calories: 165, protein: 31, fat: 3.6, carbs: 0 },
  "Vegetable Stir-fry": { calories: 50, protein: 2, fat: 1, carbs: 10 },
  "Mushrooms": { calories: 22, protein: 3.1, fat: 0.3, carbs: 3.3 },
  "Sweet Potato": { calories: 86, protein: 1.6, fat: 0.1, carbs: 20.1 },
  "Cauliflower": { calories: 25, protein: 1.9, fat: 0.3, carbs: 4.9 },
  "Chickpea Salad": { calories: 164, protein: 8.9, fat: 2.6, carbs: 27.4 },
  "Grilled Vegetables": { calories: 60, protein: 2, fat: 2, carbs: 12 },
  "Turkey Sandwich": { calories: 220, protein: 24, fat: 8, carbs: 28 },
  "Mixed Greens": { calories: 20, protein: 1, fat: 0.2, carbs: 4 },
  "Hummus": { calories: 166, protein: 7.9, fat: 9.6, carbs: 14.3 },
  "Shrimp Stir-Fry": { calories: 220, protein: 25, fat: 10, carbs: 15 },
  "Greek Yogurt with Honey": { calories: 89, protein: 10, fat: 0.4, carbs: 14 },
  "Lentil Soup": { calories: 116, protein: 9, fat: 0.4, carbs: 20 },
  "Chia Pudding": { calories: 140, protein: 5, fat: 7, carbs: 15 },
  "Beef Stir-Fry": { calories: 200, protein: 26, fat: 10, carbs: 7 },
  "Stuffed Bell Peppers": { calories: 50, protein: 1.6, fat: 0.2, carbs: 10 },
  "Baked Zucchini": { calories: 17, protein: 1.2, fat: 0.3, carbs: 3.1 },
};

const NutritionCalculator = ({ ingredients }) => {
  const [servingSize, setServingSize] = useState(100); // Default serving size is 100g

  // Calculate the total nutrition for all ingredients
  const totalNutrition = ingredients.reduce(
    (totals, ingredient) => {
      const nutrition = nutritionData[ingredient] || { calories: 0, protein: 0, fat: 0, carbs: 0 };
      return {
        calories: totals.calories + (nutrition.calories * servingSize) / 100,
        protein: totals.protein + (nutrition.protein * servingSize) / 100,
        fat: totals.fat + (nutrition.fat * servingSize) / 100,
        carbs: totals.carbs + (nutrition.carbs * servingSize) / 100,
      };
    },
    { calories: 0, protein: 0, fat: 0, carbs: 0 }
  );

  return (
    <div className="nutrition-calculator">
      <h4>Nutrition Calculator</h4>
      <label htmlFor="servingSize">Serving Size (in grams): </label>
      <input
        type="number"
        id="servingSize"
        value={servingSize}
        onChange={(e) => setServingSize(e.target.value)}
      />

      <div className="nutrition-values">
        <p><strong>Calories:</strong> {totalNutrition.calories.toFixed(2)}</p>
        <p><strong>Protein:</strong> {totalNutrition.protein.toFixed(2)}g</p>
        <p><strong>Fat:</strong> {totalNutrition.fat.toFixed(2)}g</p>
        <p><strong>Carbs:</strong> {totalNutrition.carbs.toFixed(2)}g</p>
      </div>
    </div>
  );
};

export default NutritionCalculator;
